/**
 * Created by Astha on 4/18/2018.
 */
import { Logger } from './../../logger/Logger';
import {
   RequestOTPForLoginQuery,
   RequestOTPForLoginMessage
} from "../../autogenerated/ZoomBridge";
export default class RequestOTPForLogin {
  constructor() {
    this.logger = new Logger('RequestOTPForLogin');
  }

  /**
   *
   *
   * @type {string} username
   * @public
   */

  requestOTP(username){
    const query  = new RequestOTPForLoginQuery();
    /**
     * @type{RequestOTPForLoginMessage}
     */
    const msg = new RequestOTPForLoginMessage();
    msg.setUsername(username);
    query.message = msg;
    return query.run();
  }

}
